/*eslint-disable*/ import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";

import Box from '@mui/material/Box';
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
// @mui/icons-material
import FormatAlignLeft from "@mui/icons-material/FormatAlignLeft";
import Favorite from "@mui/icons-material/Favorite";
// core components
import Header from "components/Header/HeaderTribalism.js";
import HeaderLinks from "components/Header/HeaderLinksTribalism.js";
import Parallax from "components/Parallax/Parallax.js";
import Footer from "components/Footer/TribalismFooter.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
// sections for this page
import SectionText from "pages-sections/blog-post/2020/07/covid-search-data/SectionText.js";
import SectionBlogInfo from "pages-sections/blog-post/2020/07/covid-search-data/SectionBlogInfo.js";
import SectionComments from "pages-sections/blog-post/SectionComments.js";
import SectionSimilarStories from "pages-sections/blog-post/2020/07/covid-search-data/SectionSimilarStories.js";
import styles from "../../../../pages-sections/services/ServicesSections.module.scss";






export const metadata = {
  title: "Using search data to identify covid-19 hotspots in Australia - Identifying Covid-19 Hotspots using Search Data - Tribalism",
  date: "2020-07-15",
  summary: "We are an Australian Data Analytics and Digital Marketing Agency based in Melbourne. In this blog, we talk about how we identified covid hotspot using search data! The only way to get location data from searchers on google is via paid ads... read on for more 😀",
  image: "/img/posts/2020-07-15-Covid19/COVID-19_Map-resize.webp",
  url: "https://www.tribalism.com.au/blog-post/2020/07/covid-search-data",
  author: "Scott Sunderland",
};


export default function BlogPostPage() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  });
  const classes = styles;
  return (
    <div>
      <Header
        brand="/img/clients/TribalismLogoRev.png" 
        links={<HeaderLinks dropdownHoverColor="info" />}
        fixed
        color="transparent"
        title="Identifying Covid-19 Hotspots using Search Data - Tribalism"
        image="/img/posts/2020-07-15-Covid19/COVID-19_Map-resize.webp"
        url="https://www.tribalism.com.au/blog-post/2020/07/covid-search-data"
        type="article"
        description="We are an Australian Data Analytics and Digital Marketing Agency based in Melbourne. In this blog we talk about how we identified covid hostspot using search data !"
        changeColorOnScroll={{
          height: 300,
          color: "info",
        }}
      />
      <Parallax image="/img/posts/2020-07-15-Covid19/COVID-19_Map-resize.webp" filter="dark">
        <div className={classes.container}>
          <GridContainer justifyContent="center">
            <GridItem md={8} className={classes.textCenter}>
              <Box 
                sx={{
                  '& h1': {
                    fontSize: {
                      xs: '1.9rem',
                      sm: '3rem',
                      md: '3.7rem',
                      lg: '5rem',
                      xl: '6rem',
                    }
                  }
                }}
              >
                <h1 className={classes.title}>
                Using search data to identify covid-19 hotspots in Australia
                </h1>
              </Box>
              <h4 className={classes.subtitle}>
                The only way to get location data from searchers on google is via paid ads... read on for more 😀
              </h4>
              <br />
              <Button color="rose" size="lg" href="#start" round>
                <FormatAlignLeft /> Read Article
              </Button>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classes.main}>
        <div className={classes.container}>
          <SectionText />
          <SectionBlogInfo />
          <SectionComments />

        </div>
      </div>
      <SectionSimilarStories />
      <Footer
        
      />
    </div>
  );
}
